module.exports = __webpack_public_path__ + "img/vert_blanc.575ddde6.webp";